import React, { Component } from 'react';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import CallsCompletedChart from '../../components/Reports/allreports/callscompletedreport/callscompletedchart';
import SalvageCountChart from '../../components/Reports/allreports/salvagecountreport/salvagecountchart';
import DailyDepositChart from '../../components/Reports/allreports/dailydepositreport/dailydepositchart';
import StorageCountChart from '../../components/Reports/allreports/storagecountreport/storagecountchart';
import StorageDrillDownCountChart from '../../components/Reports/allreports/storagecountreport/storagedrilldowncountchart';
import UnitsReleasedChart from '../../components/Reports/allreports/unitsreleasedreport/unitsreleasedchart';
import NoAbandonedVehiclesChart from '../../components/Reports/allreports/noabandonedvehiclesreport/noabandonedvehicleschart';
import Lotchart from '../../components/Reports/allreports/InvoicesByStorageTime/Lotchart';
import {withRouter} from 'react-router-dom';

class ReportChartPage extends Component {
    render() {
        return ( <div>                                   
                        <Route exact path="/reportschart/callscompletedchart" component={CallsCompletedChart} />
                        <Route exact path="/reportschart/salvagecountchart" component={SalvageCountChart} />
                        <Route exact path="/reportschart/dailydepositchart" component={DailyDepositChart} />
                        <Route exact path="/reportschart/storagecountchart" component={StorageCountChart} />
                        <Route exact path="/reportschart/storagedrilldowncountchart" component={StorageDrillDownCountChart} />
                        <Route exact path="/reportschart/unitsreleasedchart" component={UnitsReleasedChart} />
                        <Route exact path="/reportschart/noabandonedvehicleschart" component={NoAbandonedVehiclesChart} />
                        <Route exact path="/reportschart/invoiceImpchart" component={Lotchart} />                    
        </div>)
    }

}
export default withRouter(ReportChartPage)